module.exports = __webpack_public_path__ + "static/img/ESPN_home_run_port_lg.0337b32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/espn-home-run-challenge-and-banner-campaign/ESPN_home_run_port_lg.jpg
// module id = 240
// module chunks = 2